"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Footer = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactPreferences = require("@trycourier/react-preferences");

var _reactHooks = require("@trycourier/react-hooks");

var _tinycolor = _interopRequireDefault(require("tinycolor2"));

var _useOnScroll = require("../../hooks/use-on-scroll");

var _Header = _interopRequireDefault(require("./Header"));

var _LoadingMessages = _interopRequireDefault(require("./LoadingMessages"));

var _LoadingMore = _interopRequireDefault(require("./LoadingMore"));

var _Message = _interopRequireDefault(require("./Message"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _deepExtend = _interopRequireDefault(require("deep-extend"));

var _styled = require("./styled");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CourierLogo = function CourierLogo(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.55 5.565a.255.255 0 0 0 .04-.132A5.837 5.837 0 0 0 5.841.607C2.611.607-.013 3.244 0 6.487c.026 3.152 2.677 5.79 5.815 5.79a5.83 5.83 0 0 0 5.63-4.22c.027-.08-.026-.172-.105-.211l-.237-.093a3.205 3.205 0 0 0-2.809.33c-.382.25-.66.448-.66.448a3.018 3.018 0 0 1-1.66.515c-1.649 0-2.796-1.345-2.98-2.98l-.133-.897a.769.769 0 0 0-.487-.607l-.33-.131c-.053-.027-.08-.093-.04-.145C3.415 2.4 5.143 2.809 5.143 2.809c.303.026.567.145.777.29.304.21.541.514.686.857a3.442 3.442 0 0 0 3.152 2.07c0 .013 1.345.066 1.793-.461z",
    fill: "#586276"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.587 4.167a.343.343 0 1 0 0-.686.343.343 0 0 0 0 .686zM3.653 5.947c.079.527.5 2.215 2.373 2.518.026 0 .04-.04.013-.052-.435-.198-1.569-.857-2.334-2.492-.013-.014-.052 0-.052.026zM20.61 8.017c0 2.374-1.807 4.154-4.167 4.154s-4.154-1.767-4.154-4.154c0-2.413 1.794-4.193 4.154-4.193 2.373-.013 4.167 1.78 4.167 4.193zm-5.75 0c0 .95.686 1.648 1.596 1.648.923 0 1.609-.698 1.609-1.648 0-.976-.686-1.688-1.609-1.688-.91-.013-1.595.712-1.595 1.688zM29.207 8.268c0 2.28-1.596 3.89-3.837 3.89-2.255 0-3.877-1.61-3.877-3.89V3.969h2.598v4.299c0 .844.487 1.384 1.265 1.384.752 0 1.253-.54 1.253-1.384V3.969h2.585v4.299h.013zM35.628 3.916V6.29a4.71 4.71 0 0 0-.83-.092c-1.095 0-1.965.567-1.965 2.096V12h-2.598V3.982h2.598v.844c.475-.633 1.16-.989 2.03-.989.238 0 .488.027.765.08zM39.478 1.543c0 .844-.698 1.556-1.542 1.556a1.576 1.576 0 0 1-1.556-1.556c0-.83.712-1.543 1.556-1.543.844-.013 1.542.712 1.542 1.543zm-.263 2.44v8.016h-2.598V3.982h2.598zM48.208 8.663h-5.723c.198.831.883 1.345 1.767 1.345.778 0 1.226-.33 1.332-.765h2.558c-.25 1.767-1.754 2.915-3.811 2.915-2.373 0-4.233-1.833-4.233-4.194 0-2.347 1.82-4.153 4.18-4.153 2.176 0 3.982 1.727 3.982 3.916.014.224-.026.646-.052.936zm-2.664-1.648c-.066-.646-.686-1.094-1.384-1.094-.712 0-1.28.33-1.556 1.094h2.94zM54.55 3.916V6.29a4.71 4.71 0 0 0-.83-.092c-1.095 0-1.965.567-1.965 2.096V12h-2.598V3.982h2.598v.844c.474-.633 1.16-.989 2.03-.989.25 0 .501.027.765.08z",
    fill: "#586276"
  }));
};

CourierLogo.defaultProps = {
  width: "55",
  height: "13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ResponsiveContainer = _styledComponents["default"].div.withConfig({
  displayName: "Messages20__ResponsiveContainer",
  componentId: "sc-1lagroi-0"
})(function (_ref) {
  var theme = _ref.theme,
      isMobile = _ref.isMobile;
  return (0, _deepExtend["default"])(_objectSpread({}, isMobile ? {
    "*, &": {
      boxSizing: "border-box"
    },
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh"
  } : {
    "*, &": {
      boxSizing: "border-box"
    },
    background: "#F2F6F9"
  }), theme === null || theme === void 0 ? void 0 : theme.container);
});

var DismissInbox = _styledComponents["default"].button.withConfig({
  displayName: "Messages20__DismissInbox",
  componentId: "sc-1lagroi-1"
})(function (_ref2) {
  var theme = _ref2.theme;
  return (0, _deepExtend["default"])({
    border: "none",
    borderRadius: "50%",
    position: "absolute",
    top: 6,
    right: 8,
    cursor: "pointer",
    width: 42,
    height: 42,
    background: "rgba(115, 129, 155, 0.6)",
    color: "white",
    transition: "background 100ms ease-in",
    "&:hover": {
      background: "rgba(115, 129, 155, 0.8)"
    }
  }, theme === null || theme === void 0 ? void 0 : theme.dismissInbox);
});

var MessageList = _styledComponents["default"].div.withConfig({
  displayName: "Messages20__MessageList",
  componentId: "sc-1lagroi-2"
})(function (_ref3) {
  var _theme$messageList;

  var isMobile = _ref3.isMobile,
      theme = _ref3.theme;
  var defaultHeight = 342;

  var height = function () {
    if (!isMobile) {
      return defaultHeight;
    }

    return "Calc(100vh - 90px)";
  }();

  return (0, _deepExtend["default"])({
    position: "relative",
    background: "rgb(242, 246, 249)",
    overflow: "scroll",
    display: "flex",
    height: height,
    maxHeight: height,
    flexDirection: "column"
  }, theme === null || theme === void 0 ? void 0 : (_theme$messageList = theme.messageList) === null || _theme$messageList === void 0 ? void 0 : _theme$messageList.container);
});

var Footer = _styledComponents["default"].div.withConfig({
  displayName: "Messages20__Footer",
  componentId: "sc-1lagroi-3"
})(function (_ref4) {
  var theme = _ref4.theme;
  return (0, _deepExtend["default"])({
    alignItems: "center",
    background: "white",
    display: "flex",
    fontSize: "10px",
    fontStyle: "normal",
    position: "relative",
    zIndex: 1,
    fontWeight: "700",
    lineHeight: "14px",
    letterSpacing: "0.1rem",
    height: 36,
    justifyContent: "center",
    paddingRight: 18,
    svg: {
      marginLeft: -3,
      marginTop: -4
    },
    a: {
      display: "flex",
      alignItems: "center",
      textDecoration: "none",
      color: "rgba(86, 96, 116, 0.8)"
    }
  }, theme === null || theme === void 0 ? void 0 : theme.footer);
});

exports.Footer = Footer;

var ScrollTop = _styledComponents["default"].button.withConfig({
  displayName: "Messages20__ScrollTop",
  componentId: "sc-1lagroi-4"
})(function (_ref5) {
  var _theme$brand, _theme$brand$colors, _theme$messageList2;

  var theme = _ref5.theme,
      text = _ref5.text;
  var primaryColor = (_theme$brand = theme.brand) === null || _theme$brand === void 0 ? void 0 : (_theme$brand$colors = _theme$brand.colors) === null || _theme$brand$colors === void 0 ? void 0 : _theme$brand$colors.primary;
  var tcPrimaryColor = (0, _tinycolor["default"])(primaryColor);
  var lighten30 = tcPrimaryColor.lighten(30);
  return (0, _deepExtend["default"])({}, {
    position: "sticky",
    top: "-1px",
    width: "100%",
    height: "3px",
    zIndex: 1,
    fontSize: "12px",
    cursor: "pointer",
    background: lighten30.toString(),
    transition: "all 150ms ease-in",
    "&.hidden": {
      opacity: 0,
      visibility: "hidden"
    },
    "&::before": {
      transition: "all 150ms ease-in",
      boxSizing: "border-box",
      marginTop: "-10px",
      content: "'".concat(text, "'"),
      position: "absolute",
      left: "50%",
      transform: "translateX(-50%)",
      padding: "2px 8px",
      display: "inline-block",
      borderRadius: "10px",
      background: lighten30.toString(),
      height: "18px",
      "&:hover": {
        background: lighten30.darken(10).toString()
      }
    },
    "&.stickied": {
      "&::before": {
        marginTop: "6px"
      },
      boxShadow: "0px 8px 24px rgba(28, 39, 58, 0.3)"
    },
    border: "none"
  }, theme === null || theme === void 0 ? void 0 : (_theme$messageList2 = theme.messageList) === null || _theme$messageList2 === void 0 ? void 0 : _theme$messageList2.scrollTop);
});

var Messages = /*#__PURE__*/_react["default"].forwardRef(function (_ref6, ref) {
  var _brand$inapp5;

  var defaultIcon = _ref6.defaultIcon,
      formatDate = _ref6.formatDate,
      isMobile = _ref6.isMobile,
      labels = _ref6.labels,
      openLinksInNewTab = _ref6.openLinksInNewTab,
      renderFooter = _ref6.renderFooter,
      renderHeader = _ref6.renderHeader,
      renderMessage = _ref6.renderMessage,
      renderNoMessages = _ref6.renderNoMessages,
      renderPin = _ref6.renderPin,
      views = _ref6.views,
      title = _ref6.title;

  var _useState = (0, _react.useState)(""),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      focusedMessageId = _useState2[0],
      setFocusedMessageId = _useState2[1];

  var _usePreferences = (0, _reactHooks.usePreferences)(),
      fetchRecipientPreferences = _usePreferences.fetchRecipientPreferences;

  var _useInbox = (0, _reactHooks.useInbox)(),
      tenantId = _useInbox.tenantId,
      brand = _useInbox.brand,
      fetchMessages = _useInbox.fetchMessages,
      getUnreadMessageCount = _useInbox.getUnreadMessageCount,
      isLoading = _useInbox.isLoading,
      markAllAsRead = _useInbox.markAllAsRead,
      _useInbox$messages = _useInbox.messages,
      messages = _useInbox$messages === void 0 ? [] : _useInbox$messages,
      _useInbox$pinned = _useInbox.pinned,
      pinned = _useInbox$pinned === void 0 ? [] : _useInbox$pinned,
      startCursor = _useInbox.startCursor,
      toggleInbox = _useInbox.toggleInbox,
      unreadMessageCount = _useInbox.unreadMessageCount,
      view = _useInbox.view;

  var scrollTopRef = (0, _react.useRef)(null);
  var messageListRef = (0, _react.useRef)(null);
  var currentView = (0, _react.useMemo)(function () {
    return views === null || views === void 0 ? void 0 : views.find(function (v) {
      return v.id === view;
    });
  }, [views, view]);
  (0, _react.useEffect)(function () {
    if (view === "preferences") {
      return;
    }

    fetchMessages({
      params: _objectSpread(_objectSpread({}, currentView === null || currentView === void 0 ? void 0 : currentView.params), {}, {
        tenantId: tenantId
      })
    });
  }, [tenantId, view, currentView]);
  (0, _useOnScroll.useOnScroll)(messageListRef, {
    onScroll: function onScroll(element) {
      var _scrollTopRef$current, _scrollTopRef$current2;

      if (!element || !scrollTopRef.current) {
        return;
      }

      var classList = scrollTopRef === null || scrollTopRef === void 0 ? void 0 : (_scrollTopRef$current = scrollTopRef.current) === null || _scrollTopRef$current === void 0 ? void 0 : _scrollTopRef$current.classList;

      if (element.scrollTop < 10 && !(classList !== null && classList !== void 0 && classList.contains("hidden"))) {
        classList.add("hidden");
      }

      if (element.scrollTop >= 10 && classList !== null && classList !== void 0 && classList.contains("hidden")) {
        classList.remove("hidden");
      }

      var isSticky = (scrollTopRef === null || scrollTopRef === void 0 ? void 0 : (_scrollTopRef$current2 = scrollTopRef.current) === null || _scrollTopRef$current2 === void 0 ? void 0 : _scrollTopRef$current2.offsetTop) - (element === null || element === void 0 ? void 0 : element.scrollTop) < 7;

      if (isSticky && !(classList !== null && classList !== void 0 && classList.contains("stickied"))) {
        var _scrollTopRef$current3;

        scrollTopRef === null || scrollTopRef === void 0 ? void 0 : (_scrollTopRef$current3 = scrollTopRef.current) === null || _scrollTopRef$current3 === void 0 ? void 0 : _scrollTopRef$current3.classList.add("stickied");
      }

      if (!isSticky && classList !== null && classList !== void 0 && classList.contains("stickied")) {
        var _scrollTopRef$current4;

        scrollTopRef === null || scrollTopRef === void 0 ? void 0 : (_scrollTopRef$current4 = scrollTopRef.current) === null || _scrollTopRef$current4 === void 0 ? void 0 : _scrollTopRef$current4.classList.remove("stickied");
      }
    },
    atBottom: function atBottom() {
      if (isLoading || !startCursor) {
        return;
      }

      fetchMessages({
        after: startCursor,
        params: currentView === null || currentView === void 0 ? void 0 : currentView.params
      });
    }
  }, [scrollTopRef.current, isLoading, startCursor, currentView]);
  (0, _react.useEffect)(function () {
    fetchRecipientPreferences(tenantId);
  }, []);

  var handleCloseInbox = function handleCloseInbox(event) {
    event.preventDefault();
    toggleInbox(false);
  };

  var handleClickScrollTop = function handleClickScrollTop() {
    getUnreadMessageCount();
    fetchMessages({
      params: currentView === null || currentView === void 0 ? void 0 : currentView.params
    });

    if (messageListRef.current) {
      messageListRef.current.scrollTop = 0;
    }
  };

  var scrollTopMessage = (0, _react.useMemo)(function () {
    if (typeof (labels === null || labels === void 0 ? void 0 : labels.scrollTop) === "string") {
      return labels === null || labels === void 0 ? void 0 : labels.scrollTop;
    }

    if (typeof (labels === null || labels === void 0 ? void 0 : labels.scrollTop) === "function") {
      return labels === null || labels === void 0 ? void 0 : labels.scrollTop(String(pinned.length));
    }

    if (pinned.length) {
      var _brand$inapp, _brand$inapp$slots, _brand$inapp2, _brand$inapp2$slots, _brand$inapp2$slots$, _brand$inapp2$slots$$;

      var label = (brand === null || brand === void 0 ? void 0 : (_brand$inapp = brand.inapp) === null || _brand$inapp === void 0 ? void 0 : (_brand$inapp$slots = _brand$inapp.slots) === null || _brand$inapp$slots === void 0 ? void 0 : _brand$inapp$slots.length) === 1 ? brand === null || brand === void 0 ? void 0 : (_brand$inapp2 = brand.inapp) === null || _brand$inapp2 === void 0 ? void 0 : (_brand$inapp2$slots = _brand$inapp2.slots) === null || _brand$inapp2$slots === void 0 ? void 0 : (_brand$inapp2$slots$ = _brand$inapp2$slots[0]) === null || _brand$inapp2$slots$ === void 0 ? void 0 : (_brand$inapp2$slots$$ = _brand$inapp2$slots$.label) === null || _brand$inapp2$slots$$ === void 0 ? void 0 : _brand$inapp2$slots$$.value : "Important";
      return "".concat(pinned.length, " ").concat(label !== null && label !== void 0 ? label : "Important");
    }

    return "Scroll Top";
  }, [pinned.length, brand, labels === null || labels === void 0 ? void 0 : labels.scrollTop]);
  return /*#__PURE__*/_react["default"].createElement(ResponsiveContainer, {
    ref: ref,
    isMobile: isMobile
  }, isMobile && /*#__PURE__*/_react["default"].createElement(DismissInbox, {
    onClick: handleCloseInbox
  }, "X"), renderHeader ? renderHeader({
    labels: labels,
    markAllAsRead: markAllAsRead,
    messages: messages,
    title: title,
    unreadMessageCount: unreadMessageCount
  }) : /*#__PURE__*/_react["default"].createElement(_Header["default"], {
    labels: labels,
    markAllAsRead: markAllAsRead,
    messages: messages,
    views: views,
    title: title,
    unreadMessageCount: unreadMessageCount
  }), /*#__PURE__*/_react["default"].createElement(_styled.PositionRelative, null, view !== "preferences" ? /*#__PURE__*/_react["default"].createElement(MessageList, {
    ref: messageListRef,
    isMobile: isMobile,
    "data-testid": "messages"
  }, pinned === null || pinned === void 0 ? void 0 : pinned.map(function (message) {
    var _brand$inapp3;

    return renderMessage ? renderMessage(message) : /*#__PURE__*/_react["default"].createElement(_Message["default"], (0, _extends2["default"])({}, message, {
      isMobile: isMobile,
      defaultIcon: defaultIcon,
      formatDate: formatDate,
      isMessageFocused: focusedMessageId === message.messageId,
      key: message.messageId,
      labels: labels,
      openLinksInNewTab: openLinksInNewTab,
      renderPin: renderPin,
      renderActionsAsButtons: brand === null || brand === void 0 ? void 0 : (_brand$inapp3 = brand.inapp) === null || _brand$inapp3 === void 0 ? void 0 : _brand$inapp3.renderActionsAsButtons,
      setFocusedMessageId: setFocusedMessageId
    }));
  }), /*#__PURE__*/_react["default"].createElement(ScrollTop, {
    className: "hidden",
    disabled: isLoading,
    ref: scrollTopRef,
    onClick: handleClickScrollTop,
    text: scrollTopMessage
  }), messages === null || messages === void 0 ? void 0 : messages.map(function (message) {
    var _brand$inapp4;

    return renderMessage ? renderMessage(message) : /*#__PURE__*/_react["default"].createElement(_Message["default"], (0, _extends2["default"])({}, message, {
      defaultIcon: defaultIcon,
      formatDate: formatDate,
      isMessageFocused: focusedMessageId === message.messageId,
      isMobile: isMobile,
      key: message.messageId,
      labels: labels,
      openLinksInNewTab: openLinksInNewTab,
      renderActionsAsButtons: brand === null || brand === void 0 ? void 0 : (_brand$inapp4 = brand.inapp) === null || _brand$inapp4 === void 0 ? void 0 : _brand$inapp4.renderActionsAsButtons,
      renderPin: renderPin,
      setFocusedMessageId: setFocusedMessageId
    }));
  }), !(messages !== null && messages !== void 0 && messages.length) && (isLoading || !renderNoMessages ? /*#__PURE__*/_react["default"].createElement(_LoadingMessages["default"], {
    labels: labels,
    noResults: !isLoading
  }) : renderNoMessages({})), (isLoading && (messages === null || messages === void 0 ? void 0 : messages.length) > 0 || !startCursor && messages.length > 5) && /*#__PURE__*/_react["default"].createElement(_LoadingMore["default"], {
    noResults: !isLoading
  })) : /*#__PURE__*/_react["default"].createElement(_reactPreferences.PreferenceList, {
    theme: {
      name: "2.0"
    }
  })), renderFooter ? renderFooter({}) : !(brand !== null && brand !== void 0 && (_brand$inapp5 = brand.inapp) !== null && _brand$inapp5 !== void 0 && _brand$inapp5.disableCourierFooter) && /*#__PURE__*/_react["default"].createElement(Footer, null, /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://www.courier.com"
  }, "POWERED BY\xA0\xA0", /*#__PURE__*/_react["default"].createElement(CourierLogo, null))));
});

var _default = Messages;
exports["default"] = _default;